module.exports = __webpack_public_path__ + "img/about-ob1.b12920ed.jpg";